import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getProjects } from "../services/projectService";

export default function ProjectList() {

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");

  const navigate = useNavigate();

  // ---------------------------------------------------------
  // LOAD DATA
  // ---------------------------------------------------------
  const loadData = async () => {
    try {
      setLoading(true);
      const res = await getProjects();
      setData(res.data.data || []);
    } catch (err) {
      console.error("Error loading projects", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  // ---------------------------------------------------------
  // FILTER
  // ---------------------------------------------------------
  const filteredData = data.filter(d =>
    d.project_name?.toLowerCase().includes(search.toLowerCase()) ||
    d.customer_name?.toLowerCase().includes(search.toLowerCase()) ||
    d.order_no?.toLowerCase().includes(search.toLowerCase())
  );

  // ---------------------------------------------------------
  // STATS
  // ---------------------------------------------------------
  const total = data.length;
  const draft = data.filter(d => d.status_code === "DRAFT").length;
  const active = data.filter(d => d.status_code === "ACTIVE").length;
  const completed = data.filter(d => d.status_code === "COMPLETED").length;

  // ---------------------------------------------------------
  // UI
  // ---------------------------------------------------------
  return (
    <div style={styles.container}>

      {/* ================= HEADER ================= */}
      <div style={styles.banner}>
        <div>
          <h2 style={{ color: "#fff", margin: 0 }}>Projects</h2>
          <div style={{ color: "#ddd", fontSize: 12 }}>
            Manage and track execution projects
          </div>
        </div>
      </div>

      {/* ================= STATS ================= */}
      <div style={styles.statsRow}>

        <div style={styles.card}>
          <div style={styles.cardTitle}>TOTAL PROJECTS</div>
          <div style={styles.cardValue}>{total}</div>
        </div>

        <div style={styles.card}>
          <div style={styles.cardTitle}>DRAFT</div>
          <div style={styles.cardValue}>{draft}</div>
        </div>

        <div style={styles.card}>
          <div style={styles.cardTitle}>ACTIVE</div>
          <div style={styles.cardValue}>{active}</div>
        </div>

        <div style={styles.card}>
          <div style={styles.cardTitle}>COMPLETED</div>
          <div style={styles.cardValue}>{completed}</div>
        </div>

      </div>

      {/* ================= SEARCH ================= */}
      <div style={styles.searchRow}>
        <input
          placeholder="Search Project / Customer / Order"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={styles.searchInput}
        />
      </div>

      {/* ================= TABLE ================= */}
      <div style={styles.tableCard}>

        {loading ? (
          <div style={styles.loader}>Loading...</div>
        ) : filteredData.length === 0 ? (
          <div style={styles.empty}>No projects found</div>
        ) : (
          <table style={styles.table}>

            <thead>
              <tr>
                <th>Project</th>
                <th>Customer</th>
                <th>Order</th>
                <th>Start</th>
                <th>Target</th>
                <th>Status</th>
                <th>Progress</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {filteredData.map((row) => (
                <tr key={row.id} style={styles.row}>

                  <td>{row.project_name}</td>
                  <td>{row.customer_name || "-"}</td>
                  <td>{row.order_no || "-"}</td>
                  <td>{row.start_date}</td>
                  <td>{row.target_date}</td>

                  <td>
                    <span style={getStatusStyle(row.status_code)}>
                      {row.status_code}
                    </span>
                  </td>

                  <td>{row.progress || 0}%</td>

                  <td>
                    <button
                      style={styles.viewBtn}
                      onClick={() =>
                        navigate(`/ipe/pms/project/${row.id}`)
                      }
                    >
                      View
                    </button>
                  </td>

                </tr>
              ))}
            </tbody>

          </table>
        )}

      </div>

    </div>
  );
}

// ==========================================================
// STATUS STYLE
// ==========================================================
function getStatusStyle(status) {

  if (status === "ACTIVE") {
    return styles.statusActive;
  }

  if (status === "COMPLETED") {
    return styles.statusCompleted;
  }

  return styles.statusDraft;
}

// ==========================================================
// STYLES
// ==========================================================
const styles = {

  container: {
    padding: 20,
    background: "#f9fafb",
    minHeight: "100vh"
  },

  banner: {
    background: "linear-gradient(to right, #6d28d9, #4f46e5)",
    padding: 20,
    borderRadius: 10,
    marginBottom: 15
  },

  statsRow: {
    display: "flex",
    gap: 10,
    marginBottom: 15
  },

  card: {
    flex: 1,
    background: "#fff",
    padding: 15,
    borderRadius: 8,
    boxShadow: "0 2px 6px rgba(0,0,0,0.1)"
  },

  cardTitle: {
    fontSize: 12,
    color: "#6b7280"
  },

  cardValue: {
    fontSize: 20,
    fontWeight: 600
  },

  searchRow: {
    marginBottom: 10
  },

  searchInput: {
    padding: 8,
    width: 300,
    borderRadius: 4,
    border: "1px solid #ccc"
  },

  tableCard: {
    background: "#fff",
    borderRadius: 8,
    padding: 10,
    boxShadow: "0 2px 6px rgba(0,0,0,0.1)"
  },

  table: {
    width: "100%",
    borderCollapse: "collapse"
  },

  row: {
    borderBottom: "1px solid #eee"
  },

  loader: {
    padding: 20,
    textAlign: "center"
  },

  empty: {
    padding: 20,
    textAlign: "center",
    color: "#6b7280"
  },

  viewBtn: {
    padding: "5px 10px",
    border: "1px solid #ccc",
    background: "#fff",
    cursor: "pointer"
  },

  statusActive: {
    background: "#dcfce7",
    color: "#166534",
    padding: "4px 8px",
    borderRadius: 12
  },

  statusCompleted: {
    background: "#dbeafe",
    color: "#1e40af",
    padding: "4px 8px",
    borderRadius: 12
  },

  statusDraft: {
    background: "#fef3c7",
    color: "#92400e",
    padding: "4px 8px",
    borderRadius: 12
  }
};